import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography } from "@material-ui/core";
// import { ExpandMoreIcon } from "@material-ui/core/Icon";
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';


let useStyles = makeStyles((theme) => ({
    Accordion: {
        width: "100%",
        padding: "10px",
        textAlign: "center !important",
        boxShadow: "none",
        borderBottom: "1px solid #f2f2f2",
    },
    AccordionSummary: {
        width: "100%",
        textAlign: "center !important",
    },
    titleAccordion: {
        width: "100%",
        textAlign: "center !important",
    },
    AccordionDetails: {
        backgroundColor: "#fafafa",
        display: 'block',
        padding: 0,
    },
    subMenu: {
        width: "100%",
        padding: "8px 0",
    },
    listItem: {
        textAlign: "center !important",
    },
    title: {
        width: "100%",
        padding: "10px 0",
        textAlign: "center !important",
        boxShadow: "none",
        borderBottom: "1px solid #f2f2f2",
    },
    listItemTitle: {
        backgroundColor: "transparent !important",
        textAlign: "center !important",
    }
}));

export default function Index({ data }) {

    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <div>
            {
                data?.child?.length > 0 && (
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className={classes['Accordion']}>
                        <AccordionSummary
                            //   expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            className={classes['AccordionSummary']}

                        >
                            <Typography sx={{ width: '100%', flexShrink: 0, textAlign: 'center' }} className={classes['titleAccordion']}>
                                {data?.label}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={`${classes['AccordionDetails']}`}>
                            {
                                data?.child?.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            {
                                                item?.child?.map((item, index) => {
                                                    return (
                                                        <div key={index} className={classes['subMenu']}>

                                                            {/* <Typography>{item?.label}</Typography> */}

                                                            <ListItem
                                                                className={classes.listItem}
                                                                button
                                                                key={index}
                                                                component={Link}
                                                                to={item.route}
                                                            >
                                                                <ListItemText
                                                                    primary={item.label}
                                                                    className={classes.itemText}
                                                                />
                                                                <Divider />

                                                            </ListItem>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </AccordionDetails>
                    </Accordion>
                )
            }
            {
                data?.child?.length === 0 && (
                    <div className={classes['title']}>

                        {
                            data.route.slice(0, 4) === "http" ?
                                <a target="_blank" href={data.route} style={{display:'inline-block' , padding:17}} >
                                    {data.label}
                                    {
                                        data?.badge?.title && (
                                            <span className={classes['badge']}>
                                                {data?.badge?.title}
                                            </span>
                                        )
                                    }
                                </a>
                                :
                                <List>
                                    <ListItem
                                        className={classes.listItemTitle}
                                        button
                                        component={Link}
                                        to={data?.route}
                                    >
                                        <ListItemText
                                            primary={data.label}
                                            className={classes.itemTextTitle}
                                        />
                                        <Divider />

                                    </ListItem>
                                </List>
                        }

                    </div>
                )
            }

        </div>
    );
}


